import React, { useCallback, useState } from 'react';
import { UploadedAttachmentList as SharedUploadedAttachmentList } from '@zg-rentals/satellite-components';
import type { AttachmentsUploadedForAddMessage } from '@zg-rentals/satellite-components';
import { ModalType } from '../../../../types/ModalType';
import type { AttachmentsForMessage } from '../../../MessageAttachments';
import useModal from '../../../../hooks/useModal';
import ImagesViewer from '../../../ImagesViewer';
import type { TriggerLocation } from '../../../../constants/clickstreamEvents/globals';

type Props = {
  handleRemoveUploadedAttachment(zDocId: string): void;
  uploadedAttachments: AttachmentsUploadedForAddMessage;
  listingAlias: string;
  leadId?: string | null;
  triggerLocation: TriggerLocation;
};

const UploadedAttachmentList = ({
  handleRemoveUploadedAttachment,
  uploadedAttachments,
  listingAlias,
  leadId,
  triggerLocation,
}: Props) => {
  const { activeModal, setActiveModal } = useModal();
  const [imageAttachments, setImageAttachments] = useState<AttachmentsForMessage>([]);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  const handleImageClick = useCallback(
    (zDocId: string, images: AttachmentsForMessage) => {
      const indexOfImageSelected = images.findIndex((img) => img.zDocId === zDocId);

      setImageAttachments(images);
      setSelectedImageIndex(indexOfImageSelected);
      setActiveModal(ModalType.ImagesViewer);
    },
    [setActiveModal],
  );

  return (
    <>
      {activeModal === ModalType.ImagesViewer && (
        <ImagesViewer
          imageAttachments={imageAttachments}
          selectedImageIndex={selectedImageIndex}
          listingAlias={listingAlias}
          leadId={leadId}
          triggerLocation={triggerLocation}
        />
      )}

      <SharedUploadedAttachmentList
        uploadedAttachments={uploadedAttachments}
        onRemoveAttachment={handleRemoveUploadedAttachment}
        onImageClick={handleImageClick}
      />
    </>
  );
};

export default React.memo(UploadedAttachmentList);
